import React from 'react';
import { SVGType } from '../types';

export const NoLocationMarkerIcon = ({ stroke = '#1C1327', size = 20, ...rest }: SVGType) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" fill="none" viewBox="0 0 20 21" {...rest}>
      <g
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        clipPath="url(#clip0_2556_29323)"
      >
        <path d="M14.83 14.43l-3.23 3.23c-.15.15-.34.28-.54.36-.2.08-.42.13-.64.13-.22 0-.44-.04-.64-.13-.2-.08-.39-.21-.54-.36L5.7 14.12a6.617 6.617 0 01-1.82-3.41c-.26-1.29-.13-2.63.38-3.85.25-.61.59-1.17 1.01-1.68M7.92 3.24a6.652 6.652 0 016.2.63 6.66 6.66 0 012.84 6.84c-.1.48-.24.95-.44 1.39"></path>
        <path d="M8.25 8.17a2.496 2.496 0 00.39 3.02c.47.47 1.1.73 1.77.73.5 0 .98-.15 1.39-.42M13.05 9.25c0-.66-.26-1.3-.73-1.77s-1.1-.73-1.77-.73M16.92 16.38l-13-13"></path>
      </g>
      <defs>
        <clipPath id="clip0_2556_29323">
          <path fill="#fff" d="M0 0H14.83V16.9H0z" transform="translate(3 2)"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default React.memo(NoLocationMarkerIcon);
